/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_Request_FailedInputs */

const en_reset_request_failed = /** @type {(inputs: Reset_Request_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not send the link. Try again in a moment.`)
};

/** @type {(inputs: Reset_Request_FailedInputs) => LocalizedString} */
const ar_reset_request_failed = en_reset_request_failed;

/** @type {(inputs: Reset_Request_FailedInputs) => LocalizedString} */
const he_reset_request_failed = en_reset_request_failed;

/** @type {(inputs: Reset_Request_FailedInputs) => LocalizedString} */
const ur_reset_request_failed = en_reset_request_failed;

/** @type {(inputs: Reset_Request_FailedInputs) => LocalizedString} */
const es_reset_request_failed = en_reset_request_failed;

/** @type {(inputs: Reset_Request_FailedInputs) => LocalizedString} */
const fr_reset_request_failed = en_reset_request_failed;

/** @type {(inputs: Reset_Request_FailedInputs) => LocalizedString} */
const de_reset_request_failed = en_reset_request_failed;

/** @type {(inputs: Reset_Request_FailedInputs) => LocalizedString} */
const pt_reset_request_failed = en_reset_request_failed;

/** @type {(inputs: Reset_Request_FailedInputs) => LocalizedString} */
const hi_reset_request_failed = en_reset_request_failed;

/** @type {(inputs: Reset_Request_FailedInputs) => LocalizedString} */
const bn_reset_request_failed = en_reset_request_failed;

/**
* | output |
* | --- |
* | "We could not send the link. Try again in a moment." |
*
* @param {Reset_Request_FailedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const reset_request_failed = /** @type {((inputs?: Reset_Request_FailedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Request_FailedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_reset_request_failed(inputs)
	if (locale === "he") return he_reset_request_failed(inputs)
	if (locale === "ur") return ur_reset_request_failed(inputs)
	if (locale === "es") return es_reset_request_failed(inputs)
	if (locale === "fr") return fr_reset_request_failed(inputs)
	if (locale === "de") return de_reset_request_failed(inputs)
	if (locale === "pt") return pt_reset_request_failed(inputs)
	if (locale === "hi") return hi_reset_request_failed(inputs)
	if (locale === "bn") return bn_reset_request_failed(inputs)
	return /** @type {LocalizedString} */ ("We could not send the link. Try again in a moment.")
});